module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    报名详情及审核\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    ref: "recorddata",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.recorddata,
      "label-width": "150px",
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_vm._v(_vm._s(_vm.recorddata.activity_name))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动有效时间",
      "prop": "activity_time"
    }
  }, [_vm._v(_vm._s(_vm.recorddata.start_date) + " ~ " + _vm._s(_vm.recorddata.end_date))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审核结果",
      "prop": "status"
    }
  }, [(_vm.recorddata.status == 'pending') ? _c('el-tag', {
    attrs: {
      "type": "warning",
      "size": "mini"
    }
  }, [_vm._v("待审核")]) : _vm._e(), _vm._v(" "), (_vm.recorddata.status == 'passed') ? _c('el-tag', {
    attrs: {
      "type": "success",
      "size": "mini"
    }
  }, [_vm._v("已通过")]) : _vm._e(), _vm._v(" "), (_vm.recorddata.status == 'rejected') ? _c('el-tag', {
    attrs: {
      "type": "danger",
      "size": "mini"
    }
  }, [_vm._v("已拒绝")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "报名问卷"
    }
  }, _vm._l((_vm.recorddata.content), function(item, index) {
    return _c('el-card', {
      key: index,
      staticClass: "box-card"
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _vm._l((item.formdata), function(item, key) {
      return _c('div', {
        key: key,
        staticClass: "text item"
      }, [_vm._v("\n            " + _vm._s(item.field_title) + ":  " + _vm._s(item.answer) + "\n          ")])
    })], 2)
  }), 1), _vm._v(" "), (_vm.recorddata.status == 'pending') ? _c('el-form-item', {
    attrs: {
      "label": "是否拒绝"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.status === false && _vm.recorddata.status == 'pending') ? _c('el-form-item', {
    attrs: {
      "label": "拒绝原因"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.reason),
      callback: function($$v) {
        _vm.$set(_vm.form, "reason", $$v)
      },
      expression: "form.reason"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [(_vm.recorddata.status == 'pending') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitAction
    }
  }, [_vm._v("提交审核")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-77e69e03", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77e69e03"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/selfservice/registrationrecordetail.vue
// module id = 2843
// module chunks = 0